/* HELPERS */
const encoder = new TextEncoder();
const decoder = new TextDecoder('utf-8', { ignoreBOM: true });
/* MAIN */
const U8 = {
    /* API */
    encode: (data) => {
        return encoder.encode(data);
    },
    decode: (data) => {
        return decoder.decode(data);
    }
};
/* EXPORT */
export default U8;
